import { Header, Item, Popup, Widget } from '@revolut-internal/ui-kit'
import { FC } from 'react'

import { assistantCapabilities } from 'pages/AssistantPlayground/assistantCapabilities'

interface AssistantPlaygroundCapabilitiesModalProps {
  open: boolean
  onClose: () => void
}

export const AssistantPlaygroundCapabilitiesModal: FC<
  AssistantPlaygroundCapabilitiesModalProps
> = ({ open, onClose }) => {
  return (
    <Popup open={open} onClose={onClose} variant="bottom-sheet">
      <Header variant="compact">
        <Header.CloseButton aria-label="Close" />
        <Header.Title>Version {assistantCapabilities.version}</Header.Title>
      </Header>

      <Widget>
        {assistantCapabilities.capabilities.map((capability, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Item key={index} useIcon="Dot" iconColor="foreground">
            <Item.Content>
              <Item.Title>{capability.title}</Item.Title>
              <Item.Description>{capability.description}</Item.Description>
            </Item.Content>
          </Item>
        ))}
      </Widget>
    </Popup>
  )
}
